import { sanitizeCallableErrorMessage } from '@/utils/sanitizeCallableErrorMessage';

const INVITATION_ACCEPT_FALLBACK =
  "We couldn't complete your invitation. Please try again or ask your admin for help.";

export function getAcceptErrorMessage(error: unknown): string {
  return sanitizeCallableErrorMessage(error, INVITATION_ACCEPT_FALLBACK);
}
